import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  MenuItem,
  Paper,
  Select,
  TextField,
} from "@mui/material";
// import axios from "axios";
import React, { useEffect, useState } from "react";
import { TfqaType } from "./TfqaTable";
import api from "../../../../../API";
import { useSelector } from "react-redux";
import _debounce from 'lodash/debounce';
import VieJsonDialog from "../../VieJsonDialog";


interface tfqaDetailProps {
  setDialogOpen: React.Dispatch<React.SetStateAction<boolean>>;
  rowDetail: TfqaType | null;
  setRowDetail: React.Dispatch<React.SetStateAction<TfqaType>>;
  getTfqaList: any;
  p_order:any;
  p_prc_yn:any;
  p_use_check:any;
  p_worker:any;
  p_prc_s_date:string;
  p_prc_e_date:string;
}

const initailData: TfqaType = {
  idx: -1,
  id: "",
  worker: "",
  work_date: "",
  work_yn: "",
  use_check: "",

  prc_worker: "",
  prc_date: "",
  prc_yn: "",

  isp_worker: "",
  isp_date: "",
  isp_yn: "",

  category: "",
  answer: "",

  translate_need:"",

  question_vi : "",
  best_answer_vi : "",
  correct_answer_vi_1 : "",
  correct_answer_vi_2 : "",
  correct_answer_vi_3 : "",
  correct_answer_vi_4 : "",
  correct_answer_vi_5 : "",
  correct_answer_vi_6 : "",
  incorrect_answer_vi_1 : "",
  incorrect_answer_vi_2 : "",
  incorrect_answer_vi_3 : "",
  incorrect_answer_vi_4 : "",
  incorrect_answer_vi_5 : "",
  incorrect_answer_vi_6 : "",
  
  question_ko : "",
  best_answer_ko : "",
  correct_answer_ko_1 : "",
  correct_answer_ko_2 : "",
  correct_answer_ko_3 : "",
  correct_answer_ko_4 : "",
  correct_answer_ko_5 : "",
  correct_answer_ko_6 : "",
  incorrect_answer_ko_1 : "",
  incorrect_answer_ko_2 : "",
  incorrect_answer_ko_3 : "",
  incorrect_answer_ko_4 : "",
  incorrect_answer_ko_5 : "",
  incorrect_answer_ko_6 : "",
  
  question_en : "",
  best_answer_en : "",
  correct_answer_en_1 : "",
  correct_answer_en_2 : "",
  correct_answer_en_3 : "",
  correct_answer_en_4 : "",
  correct_answer_en_5 : "",
  correct_answer_en_6 : "",
  incorrect_answer_en_1 : "",
  incorrect_answer_en_2 : "",
  incorrect_answer_en_3 : "",
  incorrect_answer_en_4 : "",
  incorrect_answer_en_5 : "",
  incorrect_answer_en_6 : "",
};


const TfqaDetailDialog = (props: tfqaDetailProps) => {
  // console.log("props", props);

  const [data, setData] = useState<TfqaType>(initailData);

  const [openJsonDialog, setOpenJsonDialog] = useState<boolean>(false)

  const [auths, setAuths] = useState([]);
  
  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;

  

  // stt 수정 함수

  const getAuths = async () => {
    var result = await api.get("/getAuths");

    setAuths(result.data.data);
    // console.log('result.data.data',result.data.data)
  };


  const saveTfqaData = async () => {

    const formData = new FormData();

    if(data.category == "None"){
      alert('Category 를 선택하세요.')
      return;
    }

    formData.append("email", email);

    formData.append("datas", JSON.stringify(data));

    console.log('수정할 데이터', JSON.stringify(data))

    // formData.append("nvConScript", JSON.stringify(con_script));

    await api.post("/vie-04-tfqaUpdate",formData)
    .then((res:any) => { alert("업데이트가 완료되었습니다."); props.setDialogOpen(false); props.getTfqaList(props.p_order,props.p_prc_yn,props.p_use_check,props.p_worker,props.p_prc_s_date,props.p_prc_e_date); })
    .catch((error:any) => {alert('오류 - '+ error.response.data.error);})

  }

  const openGuideWindow = () => {
    const imageUrl = `${process.env.PUBLIC_URL}/img/vie-task/Vie-TruthfulQA.jpg`;

    window.open(imageUrl, '_blank');
  }

  useEffect(() => {
    getAuths();
    setData(initailData);
    // console.log("sampleDetailDialog");
    if (props.rowDetail != null){
      setData(props.rowDetail);
      // if(props.rowDetail.state)
      console.log('로우 디테일',props.rowDetail)
    }
    
  }, [props.rowDetail]);

  return (
    <Box>
      <Dialog maxWidth="xl" open={true} fullWidth={true}>
        <DialogTitle sx={{padding: "16px 24px 0px 24px"}}>
          <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px"}}>Task-04. TFQA 데이터 확인</Box>
          <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
        </DialogTitle>
        <DialogContent dividers>
          <Box>
            <Box sx={{position: "sticky",top: "-16px", zIndex: 1, backgroundColor:"#fff"}} >
              <Box>

                <Box display="flex" sx={{marginLeft: "50px"}}>
                  <Box sx={{width:"100%"}}>
                    <Box m={0.5} display="flex" sx={{alignItems:"center"}}>
                      <Box sx={{fontSize:"14px",fontWeight:700, width:"104px"}}>idx</Box>
                      <Box sx={{fontSize:"14px", width:"130px"}}>{data.idx}</Box>
                    </Box>
                    <Box m={0.5} display="flex" sx={{alignItems:"center"}}>
                      <Box sx={{fontSize:"14px",fontWeight:700, width:"104px"}}>id</Box>
                      <Box sx={{fontSize:"14px", width:"130px"}}>{data.id}</Box>
                    </Box>
                    <Box m={0.5} display="flex" sx={{alignItems:"center"}}>
                      <Box sx={{fontSize:"14px",fontWeight:700, width:"104px"}}>작업워커</Box>
                      <Box sx={{fontSize:"14px", width:"190px"}}>{data.worker}</Box>

                      <Box sx={{fontSize:"14px",fontWeight:700, width:"80px"}}>작업상태</Box>
                      <Box sx={{fontSize:"14px", marginLeft:"8px", padding: "2px 6px 2px 6px", borderRadius:"4px",
                          backgroundColor: (data.work_yn === "Y" ? "#27cc2f" : "#bbb"), color:"#fff"
                      }}>
                        {(data.work_yn === "Y" ? "작업완료" : "미작업")}
                      </Box>

                      <Box sx={{fontSize:"14px",fontWeight:700, width:"120px", marginLeft:"32px"}}>번역검토필요</Box>
                      <Box sx={{fontSize:"14px", marginLeft:"8px", padding: "2px 6px 2px 6px", borderRadius:"4px",
                          backgroundColor: (data.translate_need === "Y" ? "#9c27b0" : (data.translate_need === "None" ? "#bbb" : "#27cc2f")), color:"#fff"
                      }}>
                        {(data.translate_need === "Y" ? "검토필요" : (data.translate_need === "None" ? "미작업" : "검토완료"))}
                      </Box>
                    </Box>
                    <Box m={0.5} display="flex" sx={{alignItems:"center"}}>
                      <Box sx={{fontSize:"14px",fontWeight:700, width:"104px"}}>업로드시간</Box>
                      <Box sx={{fontSize:"14px", width:"190px"}}>{data.work_date}</Box>
                      <Box sx={{fontSize:"14px",fontWeight:700, width:"80px"}}>체크결과</Box>
                      <Select id="use_check" value={data.use_check} onChange={(e) => {setData({ ...data, use_check: e.target.value });}} sx={{color:"green",width:"180px",height: "35px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                        <MenuItem dense value={"T"}>T - 사용가능</MenuItem>
                        <MenuItem dense value={"C"}>C - 내용수정</MenuItem>
                        <MenuItem dense value={"F"}>F - 사용불가</MenuItem>
                      </Select>
                    </Box>
                    <Box m={0.5} display="flex" sx={{alignItems:"center"}}>
                      <Box sx={{fontSize:"14px",fontWeight:700, width:"96px"}}>Category</Box>
                      <Select id="category" value={data.category} onChange={(e) => {setData({ ...data, category: e.target.value });}} sx={{color:"green",width:"180px",height: "35px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                        <MenuItem dense value={"사회/정치/산업"}>사회/정치/산업</MenuItem>
                        <MenuItem dense value={"건강/의학"}>건강/의학</MenuItem>
                        <MenuItem dense value={"날씨/자연/동식물"}>날씨/자연/동식물</MenuItem>
                        <MenuItem dense value={"음식/일상생활"}>음식/일상생활</MenuItem>
                        <MenuItem dense value={"IT/과학"}>IT/과학</MenuItem>
                        <MenuItem dense value={"역사/문화/예술/공예/의상"}>역사/문화/예술/공예/의상</MenuItem>
                        <MenuItem dense value={"일반상식/기타"}>일반상식/기타</MenuItem>
                      </Select>
                      <Button variant="contained" size="small" color="secondary" sx={{fontWeight:700, margin:"8px 16px 8px 200px"}} onClick={() => openGuideWindow()}>
                        OPEN GUIDE
                      </Button>
                      <Button variant="contained" size="small" sx={{fontWeight:700, margin:"8px 16px 8px 200px", backgroundColor:"#e79055"}} onClick={() => setOpenJsonDialog(true)}>
                        OPEN JSON
                      </Button>
                      {openJsonDialog ? <VieJsonDialog task={"04"} idx={data.idx} setOpenJsonDialog={setOpenJsonDialog} />:<></>}
                    </Box>
                  </Box>
                </Box>
            
              {/* </form> */}

              <Box display="flex" justifyContent="center" >

              <Paper sx={{padding:"4px", marginRight:"16px", border:"3px solid #3e36a5"}}>
                  <Box sx={{width:"420px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                    <Box sx={{display:"flex", alignItems:"center"}}>
                      <Box sx={{display:"flex", alignItems:"center"}}>
                        <Box sx={{marginLeft:"4px"}}>
                        <Box sx={{fontSize:"22px", fontWeight:700, textAlign:"center", margin:"2px"}}>EN</Box>
                          <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Question</Box>
                          <Box><textarea value={data.question_en} onChange={(e) => {setData({ ...data, question_en: e.target.value });}} style={{width:"410px",minHeight:"55px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                  <Box sx={{width:"420px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                    <Box sx={{display:"flex", alignItems:"center"}}>
                      <Box sx={{display:"flex", alignItems:"center"}}>
                        <Box sx={{marginLeft:"4px"}}>
                          <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Best Answer</Box>
                          <Box><textarea value={data.best_answer_en} onChange={(e) => {setData({ ...data, best_answer_en: e.target.value });}} style={{width:"410px",minHeight:"40px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
              </Paper>
              <Paper sx={{padding:"4px", marginRight:"16px", border:"3px solid #3e36a5"}}>
                <Box sx={{width:"420px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{display:"flex", alignItems:"center"}}>
                      <Box sx={{marginLeft:"4px"}}>
                      <Box sx={{fontSize:"22px", fontWeight:700, textAlign:"center", margin:"2px"}}>VI</Box>
                        <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Question</Box>
                        <Box><textarea spellCheck="false" value={data.question_vi} onChange={(e) => {setData({ ...data, question_vi: e.target.value });}} style={{width:"410px",minHeight:"55px", fontSize:"18px",padding:"2px", fontFamily: "Times New Roman, serif"}}  /></Box>
                      </Box>
                    </Box>
                  </Box>
                </Box>
                <Box sx={{width:"420px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{display:"flex", alignItems:"center"}}>
                      <Box sx={{marginLeft:"4px"}}>
                        <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Best Answer</Box>
                        <Box><textarea spellCheck="false" value={data.best_answer_vi} onChange={(e) => {setData({ ...data, best_answer_vi: e.target.value });}} style={{width:"410px",minHeight:"40px", fontSize:"18px",padding:"2px", fontFamily: "Times New Roman, serif"}}  /></Box>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Paper>
              <Paper sx={{padding:"4px", marginRight:"16px", border:"3px solid #3e36a5"}}>
                <Box sx={{width:"420px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{display:"flex", alignItems:"center"}}>
                      <Box sx={{marginLeft:"4px"}}>
                      <Box sx={{fontSize:"22px", fontWeight:700, textAlign:"center", margin:"2px"}}>KO</Box>
                        <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Question</Box>
                        <Box><textarea value={data.question_ko} onChange={(e) => {setData({ ...data, question_ko: e.target.value });}} style={{width:"410px",minHeight:"55px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                      </Box>
                    </Box>
                  </Box>
                </Box>
                <Box sx={{width:"420px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{display:"flex", alignItems:"center"}}>
                      <Box sx={{marginLeft:"4px"}}>
                        <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Best Answer</Box>
                        <Box><textarea value={data.best_answer_ko} onChange={(e) => {setData({ ...data, best_answer_ko: e.target.value });}} style={{width:"410px",minHeight:"40px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Paper>

              </Box>

              </Box>

              <Box display="flex" justifyContent="center" sx={{textAlign:"center", marginTop:"2px", background: "linear-gradient(to right, #e6e6e6 30%, #deebfa 70%)"}}>
                <Box sx={{fontSize:"36px", paddingTop:"8px", color:"#60ad50", fontWeight:700,width:"100%"}}></Box>
              </Box>
              
            </Box>


            <Box sx={{height:"100%", overflow:"auto", background: "linear-gradient(to right, #e6e6e6 30%, #deebfa 70%)"}}>
              <Box display="flex" justifyContent="center" >
                  <Paper sx={{padding:"4px", marginRight:"16px", border:"3px solid #3e36a5"}}>
                  <Box sx={{backgroundColor:"#c3f1c7"}}>
                      <Box sx={{width:"420px",margin:"4px"}}>
                        <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Correct Answer</Box>
                        <Box sx={{display:"flex", alignItems:"center"}}>
                          <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                          <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>1</Box>
                            <Box><textarea value={data.correct_answer_en_1} onChange={(e) => {setData({ ...data, correct_answer_en_1: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                          </Box>
                        </Box>
                      </Box>
                      <Box sx={{width:"350px",margin:"4px"}}>
                        <Box sx={{display:"flex", alignItems:"center"}}>
                          <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                          <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>2</Box>
                          <Box><textarea value={data.correct_answer_en_2} onChange={(e) => {setData({ ...data, correct_answer_en_2: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                          </Box>
                        </Box>
                      </Box>
                      <Box sx={{width:"350px",margin:"4px"}}>
                        <Box sx={{display:"flex", alignItems:"center"}}>
                          <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                          <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>3</Box>
                          <Box><textarea value={data.correct_answer_en_3} onChange={(e) => {setData({ ...data, correct_answer_en_3: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                          </Box>
                        </Box>
                      </Box>
                      <Box sx={{width:"350px",margin:"4px"}}>
                        <Box sx={{display:"flex", alignItems:"center"}}>
                          <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                          <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>4</Box>
                          <Box><textarea value={data.correct_answer_en_4} onChange={(e) => {setData({ ...data, correct_answer_en_4: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                          </Box>
                        </Box>
                      </Box>
                      <Box sx={{width:"350px",margin:"4px"}}>
                        <Box sx={{display:"flex", alignItems:"center"}}>
                          <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                          <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>5</Box>
                          <Box><textarea value={data.correct_answer_en_5} onChange={(e) => {setData({ ...data, correct_answer_en_5: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                          </Box>
                        </Box>
                      </Box>
                      <Box sx={{width:"350px",margin:"4px"}}>
                        <Box sx={{display:"flex", alignItems:"center"}}>
                          <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                          <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>6</Box>
                          <Box><textarea value={data.correct_answer_en_6} onChange={(e) => {setData({ ...data, correct_answer_en_6: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                          </Box>
                        </Box>
                      </Box>
                  </Box>
                  <Box sx={{backgroundColor:"#ffbebe"}}>
                      <Box sx={{width:"420px",margin:"4px"}}>
                        <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Incorrect Answer</Box>
                        <Box sx={{display:"flex", alignItems:"center"}}>
                          <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                          <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>1</Box>
                            <Box><textarea value={data.incorrect_answer_en_1} onChange={(e) => {setData({ ...data, incorrect_answer_en_1: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                          </Box>
                        </Box>
                      </Box>
                      <Box sx={{width:"350px",margin:"4px"}}>
                        <Box sx={{display:"flex", alignItems:"center"}}>
                          <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                          <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>2</Box>
                          <Box><textarea value={data.incorrect_answer_en_2} onChange={(e) => {setData({ ...data, incorrect_answer_en_2: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                          </Box>
                        </Box>
                      </Box>
                      <Box sx={{width:"350px",margin:"4px"}}>
                        <Box sx={{display:"flex", alignItems:"center"}}>
                          <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                          <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>3</Box>
                          <Box><textarea value={data.incorrect_answer_en_3} onChange={(e) => {setData({ ...data, incorrect_answer_en_3: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                          </Box>
                        </Box>
                      </Box>
                      <Box sx={{width:"350px",margin:"4px"}}>
                        <Box sx={{display:"flex", alignItems:"center"}}>
                          <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                          <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>4</Box>
                          <Box><textarea value={data.incorrect_answer_en_4} onChange={(e) => {setData({ ...data, incorrect_answer_en_4: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                          </Box>
                        </Box>
                      </Box>
                      <Box sx={{width:"350px",margin:"4px"}}>
                        <Box sx={{display:"flex", alignItems:"center"}}>
                          <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                          <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>5</Box>
                          <Box><textarea value={data.incorrect_answer_en_5} onChange={(e) => {setData({ ...data, incorrect_answer_en_5: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                          </Box>
                        </Box>
                      </Box>
                      <Box sx={{width:"350px",margin:"4px"}}>
                        <Box sx={{display:"flex", alignItems:"center"}}>
                          <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                          <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>6</Box>
                          <Box><textarea value={data.incorrect_answer_en_6} onChange={(e) => {setData({ ...data, incorrect_answer_en_6: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                          </Box>
                        </Box>
                      </Box>
                  </Box>
                  </Paper>

                  <Paper sx={{padding:"4px", marginRight:"16px", border:"3px solid #3e36a5"}}>
                    <Box sx={{backgroundColor:"#c3f1c7"}}>
                          <Box sx={{width:"420px",margin:"4px"}}>
                        <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Correct Answer</Box>
                        <Box sx={{display:"flex", alignItems:"center"}}>
                          <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                          <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>1</Box>
                            <Box><textarea spellCheck="false" value={data.correct_answer_vi_1} onChange={(e) => {setData({ ...data, correct_answer_vi_1: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"18px", fontWeight:600,padding:"2px", fontFamily: "Times New Roman, serif"}}  /></Box>
                          </Box>
                        </Box>
                      </Box>
                      <Box sx={{width:"350px",margin:"4px"}}>
                        <Box sx={{display:"flex", alignItems:"center"}}>
                          <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                          <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>2</Box>
                            <Box><textarea spellCheck="false" value={data.correct_answer_vi_2} onChange={(e) => {setData({ ...data, correct_answer_vi_2: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"18px", fontWeight:600,padding:"2px", fontFamily: "Times New Roman, serif"}}  /></Box>
                          </Box>
                        </Box>
                      </Box>
                      <Box sx={{width:"350px",margin:"4px"}}>
                        <Box sx={{display:"flex", alignItems:"center"}}>
                          <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                          <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>3</Box>
                          <Box><textarea spellCheck="false" value={data.correct_answer_vi_3} onChange={(e) => {setData({ ...data, correct_answer_vi_3: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"18px", fontWeight:600,padding:"2px", fontFamily: "Times New Roman, serif"}}  /></Box>
                          </Box>
                        </Box>
                      </Box>
                      <Box sx={{width:"350px",margin:"4px"}}>
                        <Box sx={{display:"flex", alignItems:"center"}}>
                          <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                          <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>4</Box>
                          <Box><textarea spellCheck="false" value={data.correct_answer_vi_4} onChange={(e) => {setData({ ...data, correct_answer_vi_4: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"18px", fontWeight:600,padding:"2px", fontFamily: "Times New Roman, serif"}}  /></Box>
                          </Box>
                        </Box>
                      </Box>
                      <Box sx={{width:"350px",margin:"4px"}}>
                        <Box sx={{display:"flex", alignItems:"center"}}>
                          <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                          <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>5</Box>
                          <Box><textarea spellCheck="false" value={data.correct_answer_vi_5} onChange={(e) => {setData({ ...data, correct_answer_vi_5: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"18px", fontWeight:600,padding:"2px", fontFamily: "Times New Roman, serif"}}  /></Box>
                          </Box>
                        </Box>
                      </Box>
                      <Box sx={{width:"350px",margin:"4px"}}>
                        <Box sx={{display:"flex", alignItems:"center"}}>
                          <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                          <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>6</Box>
                          <Box><textarea spellCheck="false" value={data.correct_answer_vi_6} onChange={(e) => {setData({ ...data, correct_answer_vi_6: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"18px", fontWeight:600,padding:"2px", fontFamily: "Times New Roman, serif"}}  /></Box>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                    <Box sx={{backgroundColor:"#ffbebe"}}>
                          <Box sx={{width:"420px",margin:"4px"}}>
                        <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Incorrect Answer</Box>
                        <Box sx={{display:"flex", alignItems:"center"}}>
                          <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                          <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>1</Box>
                            <Box><textarea spellCheck="false" value={data.incorrect_answer_vi_1} onChange={(e) => {setData({ ...data, incorrect_answer_vi_1: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"18px", fontWeight:600,padding:"2px", fontFamily: "Times New Roman, serif"}}  /></Box>
                          </Box>
                        </Box>
                      </Box>
                      <Box sx={{width:"350px",margin:"4px"}}>
                        <Box sx={{display:"flex", alignItems:"center"}}>
                          <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                          <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>2</Box>
                            <Box><textarea spellCheck="false" value={data.incorrect_answer_vi_2} onChange={(e) => {setData({ ...data, incorrect_answer_vi_2: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"18px", fontWeight:600,padding:"2px", fontFamily: "Times New Roman, serif"}}  /></Box>
                          </Box>
                        </Box>
                      </Box>
                      <Box sx={{width:"350px",margin:"4px"}}>
                        <Box sx={{display:"flex", alignItems:"center"}}>
                          <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                          <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>3</Box>
                          <Box><textarea spellCheck="false" value={data.incorrect_answer_vi_3} onChange={(e) => {setData({ ...data, incorrect_answer_vi_3: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"18px", fontWeight:600,padding:"2px", fontFamily: "Times New Roman, serif"}}  /></Box>
                          </Box>
                        </Box>
                      </Box>
                      <Box sx={{width:"350px",margin:"4px"}}>
                        <Box sx={{display:"flex", alignItems:"center"}}>
                          <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                          <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>4</Box>
                          <Box><textarea spellCheck="false" value={data.incorrect_answer_vi_4} onChange={(e) => {setData({ ...data, incorrect_answer_vi_4: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"18px", fontWeight:600,padding:"2px", fontFamily: "Times New Roman, serif"}}  /></Box>
                          </Box>
                        </Box>
                      </Box>
                      <Box sx={{width:"350px",margin:"4px"}}>
                        <Box sx={{display:"flex", alignItems:"center"}}>
                          <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                          <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>5</Box>
                          <Box><textarea spellCheck="false" value={data.incorrect_answer_vi_5} onChange={(e) => {setData({ ...data, incorrect_answer_vi_5: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"18px", fontWeight:600,padding:"2px", fontFamily: "Times New Roman, serif"}}  /></Box>
                          </Box>
                        </Box>
                      </Box>
                      <Box sx={{width:"350px",margin:"4px"}}>
                        <Box sx={{display:"flex", alignItems:"center"}}>
                          <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                          <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>6</Box>
                          <Box><textarea spellCheck="false" value={data.incorrect_answer_vi_6} onChange={(e) => {setData({ ...data, incorrect_answer_vi_6: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"18px", fontWeight:600,padding:"2px", fontFamily: "Times New Roman, serif"}}  /></Box>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  </Paper>
                  <Paper sx={{padding:"4px", marginRight:"16px", border:"3px solid #3e36a5"}}>
                  <Box sx={{backgroundColor:"#c3f1c7"}}>
                    <Box sx={{width:"420px",margin:"4px"}}>
                      <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Correct Answer</Box>
                      <Box sx={{display:"flex", alignItems:"center"}}>
                        <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                        <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>1</Box>
                          <Box><textarea value={data.correct_answer_ko_1} onChange={(e) => {setData({ ...data, correct_answer_ko_1: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                        </Box>
                      </Box>
                    </Box>
                    <Box sx={{width:"350px",margin:"4px"}}>
                      <Box sx={{display:"flex", alignItems:"center"}}>
                        <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                        <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>2</Box>
                          <Box><textarea value={data.correct_answer_ko_2} onChange={(e) => {setData({ ...data, correct_answer_ko_2: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                        </Box>
                      </Box>
                    </Box>
                    <Box sx={{width:"350px",margin:"4px"}}>
                      <Box sx={{display:"flex", alignItems:"center"}}>
                        <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                        <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>3</Box>
                          <Box><textarea value={data.correct_answer_ko_3} onChange={(e) => {setData({ ...data, correct_answer_ko_3: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                        </Box>
                      </Box>
                    </Box>
                    <Box sx={{width:"350px",margin:"4px"}}>
                      <Box sx={{display:"flex", alignItems:"center"}}>
                        <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                        <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>4</Box>
                          <Box><textarea value={data.correct_answer_ko_4} onChange={(e) => {setData({ ...data, correct_answer_ko_4: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                        </Box>
                      </Box>
                    </Box>
                    <Box sx={{width:"350px",margin:"4px"}}>
                      <Box sx={{display:"flex", alignItems:"center"}}>
                        <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                        <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>5</Box>
                          <Box><textarea value={data.correct_answer_ko_5} onChange={(e) => {setData({ ...data, correct_answer_ko_5: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                        </Box>
                      </Box>
                    </Box>
                    <Box sx={{width:"350px",margin:"4px"}}>
                      <Box sx={{display:"flex", alignItems:"center"}}>
                        <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                        <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>6</Box>
                          <Box><textarea value={data.correct_answer_ko_6} onChange={(e) => {setData({ ...data, correct_answer_ko_6: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                  <Box sx={{backgroundColor:"#ffbebe"}}>
                    <Box sx={{width:"420px",margin:"4px"}}>
                      <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>InCorrect Answer</Box>
                      <Box sx={{display:"flex", alignItems:"center"}}>
                        <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                        <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>1</Box>
                          <Box><textarea value={data.incorrect_answer_ko_1} onChange={(e) => {setData({ ...data, incorrect_answer_ko_1: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                        </Box>
                      </Box>
                    </Box>
                    <Box sx={{width:"350px",margin:"4px"}}>
                      <Box sx={{display:"flex", alignItems:"center"}}>
                        <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                        <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>2</Box>
                          <Box><textarea value={data.incorrect_answer_ko_2} onChange={(e) => {setData({ ...data, incorrect_answer_ko_2: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                        </Box>
                      </Box>
                    </Box>
                    <Box sx={{width:"350px",margin:"4px"}}>
                      <Box sx={{display:"flex", alignItems:"center"}}>
                        <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                        <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>3</Box>
                          <Box><textarea value={data.incorrect_answer_ko_3} onChange={(e) => {setData({ ...data, incorrect_answer_ko_3: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                        </Box>
                      </Box>
                    </Box>
                    <Box sx={{width:"350px",margin:"4px"}}>
                      <Box sx={{display:"flex", alignItems:"center"}}>
                        <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                        <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>4</Box>
                          <Box><textarea value={data.incorrect_answer_ko_4} onChange={(e) => {setData({ ...data, incorrect_answer_ko_4: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                        </Box>
                      </Box>
                    </Box>
                    <Box sx={{width:"350px",margin:"4px"}}>
                      <Box sx={{display:"flex", alignItems:"center"}}>
                        <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                        <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>5</Box>
                          <Box><textarea value={data.incorrect_answer_ko_5} onChange={(e) => {setData({ ...data, incorrect_answer_ko_5: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                        </Box>
                      </Box>
                    </Box>
                    <Box sx={{width:"350px",margin:"4px"}}>
                      <Box sx={{display:"flex", alignItems:"center"}}>
                        <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                        <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>6</Box>
                          <Box><textarea value={data.incorrect_answer_ko_6} onChange={(e) => {setData({ ...data, incorrect_answer_ko_6: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                  </Paper>

              </Box>
            </Box>

          </Box>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="secondary" sx={{fontWeight:700, margin:"8px 16px"}}
            onClick={() => {
              props.setDialogOpen(false);
            }}
          >
            CANCEL
          </Button>
          <Button variant="contained" sx={{fontWeight:700, margin:"8px 16px"}}
            onClick={() => {
              saveTfqaData();
            }}
          >
            SAVE
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default TfqaDetailDialog;
